import { render } from "./form-part-b-other-information.html?vue&type=template&id=f783d024&scoped=true&ts=true&external"
import script from "./form-part-b-other-information.ts?vue&type=script&lang=ts&external"
export * from "./form-part-b-other-information.ts?vue&type=script&lang=ts&external"

import "./form-part-b-other-information.scss?vue&type=style&index=0&id=f783d024&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f783d024"]])

export default __exports__